import React from "react";
import { device } from "../../../utils";
import styled from "styled-components";
import LuxWeb3Context from '../../../context/LuxWeb3Context';

const LandingWrap = styled.div`
    text-align: center;

    .cult-button {
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate( -50%, -50% );
        padding: 5px 14px 5px 20px;
        font-size: 20px;
        @media (max-width: 767px) { font-size: 18px; }

        @media ${device.sm} {
          font-size: 24px;
          @media (max-width: 767px) { font-size: 22px; }
        }

        @media ${device.md} {
          font-size: 26px;
        }
    }
`;

class Landing extends React.Component {
    static contextType = LuxWeb3Context;

    render() {
      const { setLocationShop } = this.context;
  
      return (
        <LandingWrap>
            <div
              onClick={setLocationShop}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setLocationShop(); }}
              className="cult-button"
              role="button"
              tabIndex={0}
              aria-label="Enter shop"
            >[ Enter ]</div>
        </LandingWrap>
      );
    }
}
export default Landing;